import * as React from "react";

import { Form, Checkbox, CheckboxProps } from "semantic-ui-react";
import { QuestionWrapper } from "@teamprevent/common/questionnaires/components/questions/QuestionWrapper";

import { QuestionProps, QuestionInjectedProps } from "../../model";
import { isQuestionDisabled } from "../../questionnaireConfig/models";

import "../../styles/questions/checkbox-question.scss";
import { useQuestionnaireSectionForQuestion } from "../QuestionnaireSectionContext";

export const Checked = "Yes";

interface ContextAwareCheckboxQuestionAdditionalProps {
    value: string;
}

type ContextAwareCheckboxQuestionProps =
    Omit<QuestionProps, keyof QuestionInjectedProps | "readonly"> &
    ContextAwareCheckboxQuestionAdditionalProps &
    { readonly?: true };

// Intended to replace CheckboxQuestion, can only be used where QuestionnaireSectionContext has been provided
export const ContextAwareCheckboxQuestion = ({ onAnswerChange, ...props }: ContextAwareCheckboxQuestionProps) => {
    const { answer, showError, updateAnswer, questionText } = useQuestionnaireSectionForQuestion(props);
    const onChange = React.useCallback((_: React.MouseEvent<HTMLInputElement>, data: CheckboxProps) => {
        const newAnswer = data.checked ? props.value : "";
        updateAnswer({ answer: newAnswer });
        onAnswerChange?.(newAnswer);
    }, [onAnswerChange, props.value, updateAnswer]);
    if (isQuestionDisabled(props.questionConfig)) {
        return null;
    }
    return (
        <QuestionWrapper
            inline={props.inline}
            question={null}
            hideDivider={props.hideDivider}
            error={showError && props.mandatory && !answer ? "This field must be checked" : undefined}
            readonly={!!props.readonly}
            removable={{
                ...props.removable,
                questionId: props.questionConfig.id,
                isRemovedByUser: props.isRemovedByUser
            }}
            outdated={{
                ...props.outdated,
                questionId: props.questionConfig.id
            }}
        >
            <Form.Field>
                <Checkbox
                    label={<label dangerouslySetInnerHTML={{
                        __html: questionText
                    }} />}
                    checked={answer === props.value}
                    onChange={onChange}
                    readOnly={props.readonly}
                    className={props.readonly ? "readonly-checkbox" : ""}
                />
            </Form.Field>
        </QuestionWrapper>
    );
};
